<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="contentEventCategory.attributes"
          headline="Edit Event Category"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentEventCategories/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentEventCategory: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-event-categories/' + this.$route.params.contentEventCategoryId).then(response => {
        this.contentEventCategory = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-event-categories/' + this.$route.params.contentEventCategoryId, data)
          .then(response => {
            notify.success('The content event category was saved')

            this.contentEventCategory = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
